import type { AppMeta } from "@calcom/types/App";

import _package from "./package.json";

export const metadata = {
  name: "DocuSign",
  description: _package.description,
  installed: true,
  category: "automation",
  categories: ["automation"],
  logo: "icon.png",
  publisher: "Schedly, LLC",
  slug: "docusign",
  title: "DocuSign",
  type: "docusign_other",
  url: "https://www.docusign.com",
  variant: "automation",
  extendsFeature: "EventType",
  email: "info@schedly.io",
  dirName: "docusign",
  isOAuth: true,
} as AppMeta;

export default metadata;
